<script>
// Components
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";

// Helpers
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import FinanceUtils from '@/helpers/finance';

// Services
import FinanceDataService from "@/services/FinanceDataService";
import MarketingDataService from "@/services/MarketingDataService"

// External Components

// Lib
import isEmpty from "is-empty";

const ads = {};
const marketing = {};
const organic = {};
const adsData1 = {};
const adsData2 = {};

export default {
  name: "prices-tests",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Finance Prices Tests",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  methods: {
    ...DateUtils,
    ...FinanceUtils,

    getRequestParams() {
      const params = {};

      params['gender'] = this.filters.genders.selected;
      params['subscription'] = this.filters.subscriptions.selected;
      params['paymentMethod'] = this.filters.paymentMethod.selected;
      params['paymentProcessor'] = this.filters.paymentProcessor.selected;
      params['organic'] = this.filters.organic.selected;
      params['test'] = this.filters.tests.selected;
      params['countries'] = this.filters.countries.selected;
      if (this.filters.adsData3.selected !== 'all') {
        params['ads'] = this.filters.adsData3.selected;
      }
      else if (this.filters.adsData2.selected !== 'all') {
        params['ads'] = this.filters.adsData2.selected;
      }
      else if (this.filters.adsData1.selected !== 'all') {
        params['ads'] = this.filters.adsData1.selected;
      }
      else {
        params['ads'] = this.filters.ads.selected;
      }

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getFilters() {
      MarketingDataService.getAdsNonOrganicFilters()
          .then(response => {
            marketing.ads = response.data.filters.ads;
            response.data.filters.ads.forEach(ad => {
              this.filters.ads.options.push(ad);
            });
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.getAdsNonOrganicFilters"));
          });

      FinanceDataService.getTestsPrices()
          .then(response => {
            response.data.filters.tests.forEach(test => {
              this.filters.tests.options.push(test);
            });
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("FinanceDataService.getTestsPrices"));
          });
    },

    loadTests() {
      this.isLoading = true;
      this.isLoaded = false;
      const params = this.getRequestParams();

      if (isEmpty(params['test'])) {
        this.$toast.error("Choose a test !");
        return;
      }

      FinanceDataService
          .getTestsPricesStats(params)
          .then(response => {
            const { stats } = response.data;
            this.stats = stats;
            this.count = stats.length;
            this.isLoading = false;
            this.isLoaded = true;
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("finance.errorTransactionsNoResult"));
            this.isLoading = false;
            this.isLoaded = true;
          });
    },

    processFilters() {
      this.loadTests();
    },
  },
  mounted() {
    this.getFilters();
  },
  computed: {
    ...authComputed
  },

  watch: {
    "filters.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filters.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
    },
    "filters.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData1.selected = 'all';
      this.filters.adsData2.selected = 'all';
      this.filters.adsData3.selected = 'all';
      this.filters.adsData1.options = [{
        value: 'all', text: 'All Data1'
      }];
      this.filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(ads[newVal])) {
        MarketingDataService.getAdsNonOrganicData1Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData1.options.push(ad);
              });

              ads[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
            });
      }
      else {
        ads[newVal].forEach(ad => {
          this.filters.adsData1.options.push(ad);
        });
      }
    },
    "filters.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData2.selected = 'all';
      this.filters.adsData3.selected = 'all';
      this.filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData1[newVal])) {
        MarketingDataService.getAdsNonOrganicData2Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData2.options.push(ad);
              });

              adsData1[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
            });
      }
      else {
        adsData1[newVal].forEach(ad => {
          this.filters.adsData2.options.push(ad);
        });
      }
    },
    "filters.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData3.selected = 'all';
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData2[newVal])) {
        MarketingDataService.getAdsNonOrganicData3Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData3.options.push(ad);
              });

              adsData2[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
            });
      }
      else {
        adsData2[newVal].forEach(ad => {
          this.filters.adsData3.options.push(ad);
        });
      }
    }
  },

  data() {
    return {
      isLoading: false,
      isLoaded: false,
      title: this.$t("menuitems.finance.priceGroups"),
      stats: [],
      filters: {
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'week',
          options: [
            {value:'today', text:this.$t("dates.today")},
            {value:'yesterday', text:this.$t("dates.yesterday")},
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        tests: {
          selected: '',
          options: [
            {value:'', text: "Choose a test"}
          ]
        },
        paymentMethod: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        genders: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("users.all_genders")},
            {value: 1, text: this.$t("users.search.genderMale")},
            {value: 2, text: this.$t("users.search.genderFemale")}
          ]
        },
        subscriptions: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.subscriptions_all")},
            {value: 'sub_1_week', text: this.$t("finance.sub_1_week")},
            {value: 'sub_1_month', text: this.$t("finance.sub_1_month")},
            {value: 'sub_3_month', text: this.$t("finance.sub_3_month")},
            {value: 'sub_6_month', text: this.$t("finance.sub_6_month")},
            {value: '', text: '---------'},
            {value: 'sub_12_month', text: this.$t("finance.sub_12_month")},
            {value: 'sub_lifetime', text: this.$t("finance.sub_lifetime")},
            {value: 'sub_1_month_ft3d', text: this.$t("finance.sub_1_month_ft3d")},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
      },
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">

      <!-- Filters -->
      <div class="card">
        <div class="card-body">
          <!-- filters -->
          <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>

            <!-- Test Prices -->
            <div class="col-sm-auto">
              <b-form-select
                  id="testPricesTestsFilter"
                  v-model="filters.tests.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.tests.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Countries -->
            <div class="col-sm-auto">
              <b-form-select
                  id="testPricesCountriesFilter"
                  v-model="filters.countries.selected"
                  class="form-select me-lg-1"
                  :options="filters.countries.options">
              </b-form-select>
            </div>

            <!-- Genders -->
            <div class="col-sm-auto">
              <b-form-select
                  id="testPricesGenderFilter"
                  v-model="filters.genders.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.genders.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Subscriptions -->
            <div class="col-sm-auto">
              <b-form-select
                  id="testPricesSubFilter"
                  v-model="filters.subscriptions.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.subscriptions.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentMethod -->
            <div class="col-sm-auto">
              <b-form-select
                  id="testPricesMethodFilter"
                  v-model="filters.paymentMethod.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- PaymentProcessor -->
            <div class="col-sm-auto">
              <b-form-select
                  id="testPricesProcessorFilter"
                  v-model="filters.paymentProcessor.selected"
                  class="form-select me-lg-1"
              >
                <option v-for="ct in filters.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
              </b-form-select>
            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="testPricesOrganicFilter"
                  v-model="filters.organic.selected"
                  class="form-select me-lg-1"
                  :options="filters.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="testPricesAdsFilter"
                  v-model="filters.ads.selected"
                  class="form-select me-lg-1"
                  :options="filters.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.ads.selected !== 'all'">
              <b-form-select
                  id="testPricesAdsData1Filter"
                  v-model="filters.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData1.selected !== 'all'">
              <b-form-select
                  id="testPricesAdsData2Filter"
                  v-model="filters.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData2.selected !== 'all'">
              <b-form-select
                  id="testPricesAdsData3Filter"
                  v-model="filters.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData3.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <div v-if="!isLoading && isLoaded && stats.length === 0" class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No Group of prices were found for these filters. Try again.</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!isLoading && isLoaded && stats.length > 0" class="row">
        <div v-for="priceGroup in stats" :key="priceGroup" class="card">
          <div class="card-body">
            <h3 class="mb-4">{{ priceGroup.name }}
              <span
                  class="badge"
                  :class="{
                     'bg-info text-light': priceGroup.enabled === 1,
                     'bg-warn text-dark': priceGroup.enabled === 0,
                  }"
                  ><small>{{ priceGroup.enabled === 1 ? "LIVE" : "stop"}}</small>
              </span>
            </h3>

            <div class="row">

              <div class="col-12 col-lg-3">
                <div class="table-responsive">
                  <table
                      class="table project-list-table table-nowrap table-centered align-middle"
                  >
                    <thead class="table-light">
                    <tr>
                      <th scope="col">Leads</th>
                      <th scope="col">Payments</th>
                      <th scope="col">Renews</th>
                    </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><span class="text-dark fw-medium">{{ priceGroup.leads }}</span></td>
                        <td class="">
                          <span class="d-inline-block bg-success text-white fw-medium p-2">
                          {{ priceGroup.perf }}%
                          </span>
                          <span class="float-end text-success">{{ priceGroup.paid }}</span>
                        </td>
                        <td class="">
                          <span class="d-inline-block bg-info text-white fw-medium p-2">
                          {{ priceGroup.perf_renew }}%
                          </span>
                          <span class="float-end text-info">{{ priceGroup.paid_renews }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="col-12 col-lg-9">
                <div class="table-responsive">
                  <table
                      class="table project-list-table table-nowrap table-centered align-middle"
                  >
                    <thead class="table-light">
                    <tr>
                      <th scope="col">Product</th>
                      <th v-for="product in priceGroup.products" :key="product.name">
                        <td>{{ product.name }}</td>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td><span class="text-dark fw-medium">First</span></td>
                      <td v-for="product in priceGroup.products" :key="product.name">
                        <span class="text-success fw-medium">{{ product.first }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><span class="text-dark fw-medium">Renews</span></td>
                      <td v-for="product in priceGroup.products" :key="product.name">
                        <span class="text-info fw-medium">{{ product.renews }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                  <table
                      class="table project-list-table table-nowrap table-centered align-middle"
                  >
                    <thead class="table-light">
                    <tr>
                      <th scope="col">Currency</th>
                      <th scope="col">Total</th>
                      <th scope="col">First</th>
                      <th scope="col">First Amount</th>
                      <th scope="col">Renews</th>
                      <th scope="col">Renews Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="currency in priceGroup.currencies" :key="currency.currency">
                      <td><span class="text-dark fw-medium mb-2">{{ currency.currency }}</span></td>
                      <td class="text-dark">{{ currency.amountTotalHT / 100}} HT<span class="text-muted float-end"><small>{{ currency.amountTotal / 100}}</small></span></td>
                      <td class="text-success">{{ currency.first}}</td>
                      <td class="bg-success text-white">{{ currency.firstAmountHT / 100}} HT<span class="float-end"><small>{{ currency.firstAmount / 100}}</small></span></td>
                      <td class="text-info">{{ currency.renews}}</td>
                      <td class="bg-info text-white">{{ currency.renewsAmountHT / 100}} HT<span class="float-end"><small>{{ currency.renewsAmount / 100}}</small></span></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>

<style>

</style>
